import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";
import Button from 'react-bootstrap/Button';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { getActiveOrderList } from '../../redux/actions/orderAction';
import { UPDATE_ORDERS_URL} from "../../services/apiConstant"
import { putAPI, postAPI } from "../../services/apiService"
import { SearchBar } from "../../component/searchBar"
import './order.css';
import OrderItemPopup from './orderItemPopup'
import { OrderStatus,ReturnStatus } from './OrderEnum'
import moment from 'moment';
import PopupWithText from '../../component/PopupWithText';

import { Loader } from '../../component/loader';

const OrderList = (props) => {
  const dispatch = useDispatch();
  const [activrOderArray, setActiveOrderArray] = useState([])
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = React.useState(OrderStatus.ASSIGNED);
  const [searchText, setSearchText] = useState()
  const [showProductsPopup, setShowProductsPopup] = useState(false);
  const [selectedOrderData, setSelectedOrderData] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [cancelPopupData, setCancelPopupData] = useState(null);

  const assignedOrderList = useSelector((state) => state.getActiveOrderReducer);


  useEffect(() => {
    setLoading(true)
    dispatch(getActiveOrderList(props.user, OrderStatus.ASSIGNED));
  }, [])

  useEffect(() => {
    if (assignedOrderList) {
      console.log('OrderList', assignedOrderList)
      setLoading(false)
      setActiveOrderArray(assignedOrderList)
    }

  }, [assignedOrderList])

  useEffect(() => {
    if (selectedOrderData) {
      setShowProductsPopup(true)
    }
  }, [selectedOrderData])

  const handleCancelOpenPopup = (data) => {
    setCancelPopupData(data)
    setIsPopupOpen(true);
  }
  const handleClosePopup = () => setIsPopupOpen(false);

  const onSubmitCancel=async(data)=>{
    await updateOrderStatus(data, OrderStatus.CANCELED)
    handleClosePopup()
  }

  const getAddress = (addressDetails) => {
    if (addressDetails) {
      return `${addressDetails.fullName}, ${addressDetails.addressLine1}, ${addressDetails.addressLine2}, ${addressDetails.city}, ${addressDetails.state}, ${addressDetails.pincode}`

    }
    return ''
  }
  const updateOrderStatus = async (data, status = OrderStatus.COMPLETED, submitOrderResponse) => {
    setLoading(true);
    data.orderStatus = status
    //data.paymentInfo.paymentStatus = status === OrderStatus.COMPLETED ? status : OrderStatus.PENDING
    data.lastUpdatedTime = Date.now()
    data.completedBy = "VendorPortal"
    data.trackInfo = submitOrderResponse
    const updateorderResponse = await putAPI(UPDATE_ORDERS_URL + data.id, data);
    dispatch(getActiveOrderList(props.user, selectedTab));

  }


  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
    dispatch(getActiveOrderList(props.user, newValue));

  };

  const handleTextSearch = (event) => {
    console.log('event', event.target.value)
    setSearchText(event.target.value)
    const key = event.target.value
    if (!key) {
      setActiveOrderArray(assignedOrderList)
    }
    else {
      const filterresult = activrOderArray.filter(order => (order.orderId?.includes(key) || order.deleiveryDetails?.selectedAddress?.mobileNumber?.includes(key)))
      setActiveOrderArray(filterresult)
    }
    event.preventDefault()

  };


  const onCloseProductItemPopup = () => {
    setShowProductsPopup(false)
    setSelectedOrderData(null)

  }

  const onCompleteOrder = async() =>{
    await updateOrderStatus(selectedOrderData,OrderStatus.INTRANSIT)
    setShowProductsPopup(false)
    setSelectedOrderData(null)
  }

  const processReturnOrder = async (data, status) => {
    const updateOrder = data
    updateOrder["returnStatus"] = ReturnStatus.RETURN_PROCESS
    updateOrderStatus(updateOrder, status)
  }

  const cancelReturnOrder = async (data, status) => {
    const updateOrder = data
    updateOrder["returnStatus"] = ReturnStatus.RETURN_CANCEL
    updateOrderStatus(updateOrder, status)
  }

  const completeReturnOrder = async (data, status) => {
    const updateOrder = data
    updateOrder["returnStatus"] = ReturnStatus.RETURN_COMPLETED
    updateOrderStatus(updateOrder, status)
  }


  const handleShowDetails = (data) => {
    setSelectedOrderData(data)
  };


  const getColorBorder = () => {
    switch (selectedTab) {
      case OrderStatus.REJECTED:
        return "right-order-item red-left-border"
      case OrderStatus.COMPLETED:
        return "right-order-item-green"
      case OrderStatus.ASSIGNED:
        case OrderStatus.INTRANSIT:
        return "right-order-item-light-green"
      case OrderStatus.RETURN:
        return "right-order-item-purple"
      default:
        return "right-order-item red-left-border"
    }
  }


  const OrderView = () => {
    return <div class="product-card margin-top-3p">
      <div class="card-body">

        <div className='title-container'>
          <h5 class="card-title ">{`All ${selectedTab?.toLocaleLowerCase()} orders`}  </h5>
          <h5 class="card-title ">{`Total (${activrOderArray.length})`}  </h5>

        </div>
        {loading && <Loader loading={loading} />}

        {activrOderArray.map((data) => {
          return <div className={getColorBorder()}>

            <div className='bold-font order-title'>#{data.orderId}</div>
            {data?.orderStatus===OrderStatus.INTRANSIT && <div><span>Delivery Partner:</span> {"Assigned"}</div>}
            <div><span>Delivery Location:</span> {getAddress(data?.deleiveryDetails?.selectedAddress)}</div>
            <div><span>Mobile Number:</span> {data?.deleiveryDetails?.selectedAddress?.mobileNumber}</div>
            <div><span>Delivery Time:</span> {data?.deleiveryDetails?.deliveryTimeSlot}</div>
            <div><span>Order Status:</span> {data?.orderStatus}</div>
           {data?.cancelReason && <div><span>Cancel Reason:</span> {data?.cancelReason}</div>}
            <div><span>Products:</span> {data?.orders.map(ord => `${ord?.productDetails?.itemName} - (Quantity:${ord.quantity}), `)}
            </div>
            <div><span>Products Price:</span>
              {data?.orderStatus?.toLowerCase() === OrderStatus.RETURN ?
                data?.totalRefundAmount :
                Number(data?.paymentInfo?.totalPayment) - Number(data?.paymentInfo?.deliveryCharges)
              }
            </div>            <div><span>Delivery Charges:</span> {data?.paymentInfo?.deliveryCharges || 0}</div>
            <div><span>Total Amount:</span> Rs. {data?.orderStatus === OrderStatus.RETURN ? data?.totalRefundAmount : data?.paymentInfo?.totalPayment}</div>
            {/* <div><span>Payment Status:</span> {data?.paymentInfo?.paymentStatus.toUpperCase()}</div> */}
            {/* <div><span>Last Update Time:</span> {data?.lastUpdatedTime || data?.orderDate}</div> */}
            <div><span>Order Date:</span> {moment(data?.orderDate).format('MMMM Do YYYY, h:mm:ss a')}</div>
            <div><span>Last Update Time:</span> {moment(data?.lastUpdatedTime).format('MMMM Do YYYY, h:mm:ss a')}</div>

            {((data?.orderStatus === 'return')) &&
              <div><span>Return Status:</span> {data?.returnStatus}</div>}

            {<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              {data.orderStatus === OrderStatus.COMPLETED ? <div style={{ display: 'flex' }}>
                <div style={{ fontWeight: '700', color: 'green', marginLeft: 10, alignSelf: 'center' }}>Completed</div>
              </div>
                :
                <>
                  {
                    data.orderStatus !== OrderStatus.CANCELED && data.orderStatus !== OrderStatus.ASSIGNED && data.orderStatus !== OrderStatus.RETURN && data.orderStatus !== OrderStatus.INTRANSIT &&
                    <Button style={{ margin: 10, background: '#dc3545', border: '#dc3545' }} onClick={() => updateOrderStatus(data, OrderStatus.REJECTED)}>{"Reject Order"}</Button>}
                  {(data.orderStatus !== OrderStatus.REJECTED && data.orderStatus !== OrderStatus.ASSIGNED && data.orderStatus !== OrderStatus.CANCELED && data.orderStatus !== OrderStatus.RETURN) && data.orderStatus !== OrderStatus.INTRANSIT  ?
                    <Button className='primary-button bg-black' style={{ margin: 10, }} onClick={() => updateOrderStatus(data, OrderStatus.PENDING)}>{"Accept Order"}</Button>
                    :
                    data.orderStatus !== OrderStatus.ASSIGNED && data.orderStatus !== OrderStatus.CANCELED && data.orderStatus !== OrderStatus.RETURN && data.orderStatus !== OrderStatus.INTRANSIT && <Button className='primary-button bg-black' onClick={() => updateOrderStatus(data, OrderStatus.ASSIGNED)}>{"Move to Assigned"}</Button>
                  }
                  {data.orderStatus === OrderStatus.ASSIGNED &&
                    <>
                      {/* <Button className='primary-button  bg-green' style={{ margin: 10, }} onClick={() => updateOrderStatus(data, OrderStatus.COMPLETED)}>{"Mark as Complete"}</Button> */}
                      <Button className='primary-button bg-black' style={{ margin: 10, }} onClick={() => handleCancelOpenPopup(data)}>{"Cancel Order"}</Button>
                    </>
                  }
                  {data.orderStatus === OrderStatus.INTRANSIT &&
                    <>
                      <Button className='primary-button bg-black' style={{ margin: 10, }} onClick={() =>handleCancelOpenPopup(data)}>{"Cancel Order"}</Button>
                      <Button className='primary-button  bg-green' style={{ margin: 10, }} onClick={() => updateOrderStatus(data, OrderStatus.COMPLETED)}>{"Mark as Complete"}</Button>
                    </>
                  }

                  {data.orderStatus === OrderStatus.CANCELED &&
                    <>
                      <Button className='primary-button bg-black' style={{ margin: 10, }} onClick={() => updateOrderStatus(data, OrderStatus.ASSIGNED)}>{"Move to Assigned"}</Button>

                    </>
                  }


{data.orderStatus === OrderStatus.RETURN &&
                    <>
                      {
                        (data.returnStatus === ReturnStatus.RETURN_PROCESS || data.returnStatus === ReturnStatus.RETURN_SEND) &&
                        <Button className='primary-button  bg-green' style={{ margin: 10, }} onClick={() => completeReturnOrder(data, OrderStatus.RETURN)} >{"Mark Return Completed"}</Button>
                      }
                      {!(data.returnStatus) &&
                        <>
                          <Button className='primary-button bg-black' style={{ margin: 10, }} onClick={() => cancelReturnOrder(data, OrderStatus.RETURN)} >{"Reject Return"}</Button>
                          <Button className='primary-button' style={{ margin: 10, }} onClick={() => processReturnOrder(data, OrderStatus.RETURN)} >{"Process Return"}</Button>
                        </>

                      }

                      {data.returnStatus === ReturnStatus.RETURN_COMPLETED && <div style={{ fontWeight: '700', color: 'green', marginLeft: 10, alignSelf: 'center' }}>Return Completed</div>
                      }
                    </>
                  }

                </>
              }
            </div>
            }
              <Button className='primary-button' style={{ margin: 10, }} onClick={() => handleShowDetails(data)}>View Orders</Button>

            <hr />


          </div>
        })}

        {activrOderArray.length === 0 && <center>No Orders available...</center>}
      </div>
    </div>
  }


  return <>
   <PopupWithText isOpen={isPopupOpen} onClose={handleClosePopup} onSubmitCancel={onSubmitCancel} cancelPopupData={cancelPopupData} />
    <Box sx={{ width: '100%', typography: 'body1' }}>

      <TabContext value={selectedTab}>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

          <TabList onChange={handleChange} aria-label="orderlist" >
            <Tab label="Assigned Orders" value={OrderStatus.ASSIGNED} />
            <Tab label="In-Transit Orders" value={OrderStatus.INTRANSIT} />
            <Tab label="Completed Orders" value={OrderStatus.COMPLETED} />
            <Tab label="Return Orders" value={OrderStatus.RETURN} />
            <Tab label="Canceled Orders" value={OrderStatus.CANCELED} />
          </TabList>
          <SearchBar handleTextSearch={handleTextSearch} searchText={searchText} value={searchText} title={'Enter mobile number or orderId to search'} css={'search-right'} />

        </Box>

        <TabPanel value={OrderStatus.ASSIGNED}><OrderView /></TabPanel>
        <TabPanel value={OrderStatus.INTRANSIT}><OrderView /></TabPanel>
        <TabPanel value={OrderStatus.COMPLETED}><OrderView /></TabPanel>
        <TabPanel value={OrderStatus.RETURN}><OrderView /></TabPanel>
        <TabPanel value={OrderStatus.CANCELED}><OrderView /></TabPanel>

      </TabContext>
      {showProductsPopup && <OrderItemPopup data={selectedOrderData} onCloseProductItemPopup={onCloseProductItemPopup} onCompleteOrder={onCompleteOrder}/>}

    </Box>

  </>
}

export default OrderList;